import * as React from 'react'

import CardWithSvg, {Props as SvgCardProps} from 'airship/patterns/CardWithSvg'
import CardWithContent, {
  Props as CardProps,
} from 'airship/patterns/CardWithContent'
import {SpriteName} from 'airship/patterns/types'
import * as analytics from 'airship/modules/track'

import * as waffle from 'airship/modules/waffle'
import WaffleFlag from 'airship/modules/waffle/flags'
import getUrl = require('airship/modules/get-url')

// Array of sprite names that correspond to message types that we want to
// track for incrementing the journey usage counter in amplitude.
const JOURNEY_MESSAGE_SPRITES: SpriteName[] = [
  'composer-series',
  'welcome-series',
  'reengagement-journey',
]

const MessageTypeWithContent: React.FC<CardProps> = (props) => {
  return (
    <CardWithContent
      {...props}
      className="card__button"
      onClick={(e) => {
        if (props.onClick) props.onClick(e)
        analytics.track('Composer', 'Click', 'Create Message Type', {
          appKey: getUrl.APP_KEY,
          messageType: props.title.toLowerCase(),
        })
        if (props?.title !== undefined && props?.title === 'Journey') {
          analytics.getAnalytics().incrementProp('journeysUsageCount', 1)
        }
      }}
    />
  )
}

const MessageTypeWithIcon: React.FC<SvgCardProps> = (props) => {
  return (
    <CardWithSvg
      {...props}
      orientation="horizontal"
      onClick={(e) => {
        if (props.onClick) props.onClick(e)
        analytics.track('Composer', 'Click', 'Create Message Type', {
          appKey: getUrl.APP_KEY,
          messageType: props.title.toLowerCase(),
        })
        if (
          props.icon !== undefined &&
          JOURNEY_MESSAGE_SPRITES.includes(props.icon)
        ) {
          analytics.getAnalytics().incrementProp('journeysUsageCount', 1)
        }
      }}
    />
  )
}

const MessageType = waffle.flag_is_active(WaffleFlag.GlobalCreateReworkFlag)
  ? MessageTypeWithContent
  : MessageTypeWithIcon

export default MessageType
